import { render, staticRenderFns } from "./friendlink.vue?vue&type=template&id=3866a153&scoped=true&"
import script from "./friendlink.vue?vue&type=script&lang=js&"
export * from "./friendlink.vue?vue&type=script&lang=js&"
import style0 from "./friendlink.vue?vue&type=style&index=0&id=3866a153&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3866a153",
  null
  
)

export default component.exports